export default "__VITE_ASSET__CCycnAQd__"